import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { Sprite, Text, TextStyle } from "pixi.js";

export class TakeMeToMPButton extends ButtonWithScaleAnimation {
    private static readonly BUTTON_TEXT = 'TAKE ME TO';

    private text: Text;
    private marketplaceIcon: Sprite;

    public constructor(commonResources: CommonResourcesPackage) {
        super(commonResources.assets_common_ui_button_green_blue_png);
        this.text = new Text(TakeMeToMPButton.BUTTON_TEXT, new ButtonTextStyle());
        this.text.position.set(32, 45);

        this.marketplaceIcon = new Sprite(commonResources.assets_common_ui_vector_png);
        this.marketplaceIcon.width = 97;
        this.marketplaceIcon.height = 91;
        this.marketplaceIcon.position.set(303, 30);

        this.addChild(this.text, this.marketplaceIcon);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.78,
            dropShadowBlur: 9,
            dropShadowColor: '0D0606',
            dropShadowDistance: 5.3
        });
    }
}